import { IRect } from 'konva/lib/types';
import { memo } from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

interface IKonvaImageProps {
  imageUrl: string;
  width: number;
  height: number;
  x?: number;
  y?: number;
  rotation?: number;
  crop?: IRect;
  listening?: boolean;
  opacity?: number;
}

export const KonvaImage: React.FC<IKonvaImageProps> = memo(
  ({ imageUrl, width, height, x, y, rotation, listening, crop, opacity }) => {
    const [logoImage, status] = useImage(imageUrl, 'anonymous');

    return (
      status === 'loaded' && (
        <Image
          image={logoImage}
          width={width}
          height={height}
          x={x}
          y={y}
          rotation={rotation}
          crop={crop}
          listening={listening}
          opacity={opacity}
        />
      )
    );
  }
);
